import { render, staticRenderFns } from "./CancelarUsuarios.vue?vue&type=template&id=27e2d85a&scoped=true&"
import script from "./CancelarUsuarios.vue?vue&type=script&lang=js&"
export * from "./CancelarUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./CancelarUsuarios.vue?vue&type=style&index=0&id=27e2d85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e2d85a",
  null
  
)

export default component.exports